import { Injectable } from '@angular/core';
import { BaseDbService } from './user.service';
import { AngularFireDatabase } from 'angularfire2/database';


@Injectable({
  providedIn: 'root'
})
export class UserGroupService extends BaseDbService {
  constructor(
    protected db: AngularFireDatabase) {
    super(db, "");
  }

  add(userId: string, groupId: string) {
    return this.db.object(`${this.dbPath}/users/${userId}/groups/${groupId}`).set(true).then(() => {
      return this.db.object(`${this.dbPath}/groups/${groupId}/users/${userId}`).set(true);
    });
  }

  remove(userId: string, groupId: string): any {
    return this.db.object(`${this.dbPath}/users/${userId}/groups/${groupId}`).set(null).then(() => {
      return this.db.object(`${this.dbPath}/groups/${groupId}/users/${userId}`).set(null);
    });
  }  

  getGroups() {
    return this.db.object(`${this.dbPath}/users/${this.CurrentUser.uid}/groups`);
    // var groups = [];
    // return new Promise(resolve => {
    //   this.db.object(`${this.dbPath}/users/${this.CurrentUser.uid}`).valueChanges()
    //     .subscribe(user => {
    //       if (user['groups']) {
    //         var ids = Object.keys(user['groups']);
    //         ids.forEach(id => {
    //           this.db.object(`${this.dbPath}/groups/${id}`).valueChanges().subscribe(res => {
    //             groups = [];
    //             if (res) {
    //               res['key'] = id;
    //               groups.push(res);
    //               console.log(groups);
    //             }
    //           })
    //         })
    //       }
    //       resolve(groups);
    //     })
    // })
  }

  getMembers(groupId: string) {
    return this.db.object(`${this.dbPath}/groups/${groupId}/users`);

    // return new Promise(resolve => {
    //   var users: any = [];
    //   this.db.object(`${this.dbPath}/groups/${groupId}/users`).valueChanges()
    //     .subscribe(userIds => {
    //       users = [];
    //       Object.keys(userIds).forEach(id => {
    //         this.db.object(`${this.dbPath}/users/${id}`).valueChanges().subscribe(res => {
    //           if(res){
    //             res['id'] = id;
    //             users.push(res);
    //           }
    //         })
    //       })
    //       resolve(users);
    //     })
    // })
  }
}
